import React from "react";
import { HashLink as Link } from "react-router-hash-link";
import DataCollectionBG from "./files/dataCollectionBG.js";
import InstallationBG from "./files/installationBG.js";
import ConnectionBG from "./files/connectionBG.js";

import styles from "./tariffs.module.css";

class TariffsSlide extends React.Component {
  render() {
    return (
      <div className={styles.container}>
        <div
          style={{
            paddingTop: "3%",
            fontWeight: "600",
            flex: "1",
            textAlign: "center"
          }}
        >
          <div style={{ fontSize: "1.35vw" }}>Выберите тарифный план</div>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "baseline",
            flexDirection: "row",
            flex: "1.7"
          }}
        >
          <div style={{ flex: "1", display: "inline-block" }}>
            <div
              style={{
                display: "flex",
                textAlign: "center",
                alignItems: "center"
              }}
            >
              <div style={{ flex: "1" }} className={styles.iconTextContainer}>
                <div className={styles.iconTextContainer}>
                  <div
                    className={styles.iconContainer}
                    style={{
                      backgroundImage: <DataCollectionBG />,
                      backgroundColor: "transparent"
                    }}
                  >
                    <div className={styles.BGImg}>
                      <Link to="/tariffs#1">
                        <div>
                          <DataCollectionBG />
                        </div>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
              <div style={{ flex: "1" }} className={styles.iconTextContainer}>
                <div className={styles.iconTextContainer}>
                  <div
                    className={styles.iconContainer}
                    style={{
                      backgroundImage: <InstallationBG />,
                      backgroundColor: "transparent"
                    }}
                  >
                    <div className={styles.BGImg}>
                      <Link to="/tariffs#2">
                        <div>
                          <InstallationBG />
                        </div>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
              <div style={{ flex: "1" }} className={styles.iconTextContainer}>
                <div className={styles.iconTextContainer}>
                  <div
                    className={styles.iconContainer}
                    style={{
                      backgroundImage: <ConnectionBG />,
                      backgroundColor: "transparent"
                    }}
                  >
                    <div className={styles.BGImg}>
                      <Link to="/tariffs#3">
                        <div>
                          <ConnectionBG />
                        </div>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "baseline",
            flexDirection: "row",
            flex: "2"
          }}
        >
          <div
            style={{
              flex: "1",
              marginLeft: "1vw",
              marginRight: "1vw",
              backgroundColor: "#eaf0f3",
              borderRadius: "12px"
            }}
          >
            <div
              style={{
                borderRadius: "12px",
                padding: "0.3vw",
                paddingLeft: "0.4vw",
                paddingRight: "0.4vw"
              }}
            >
              <ul
                className="globalUlList"
                style={{ paddingInlineStart: "1.85em" }}
              >
                <li>
                  сбор часовых и суточных архивов с теплосчетчиков каждые сутки;
                </li>
                <li>формирование документа в формате HTML-XML МОЭК;</li>
                <li>техническая поддержка.</li>
              </ul>
            </div>
          </div>
          <div
            style={{
              flex: "1",
              marginLeft: "1vw",
              marginRight: "1vw",
              backgroundColor: "#eaf0f3",
              borderRadius: "12px"
            }}
          >
            <div
              style={{
                borderRadius: "12px",
                padding: "0.3vw",
                paddingLeft: "0.4vw",
                paddingRight: "0.4vw"
              }}
            >
              <ul
                className="globalUlList"
                style={{ paddingInlineStart: "1.85em" }}
              >
                <li>
                  сбор часовых и суточных архивов с теплосчетчиков каждые сутки;
                </li>
                <li>формирование документа в формате HTML-XML МОЭК;</li>
                <li>чтение текущих значений online;</li>
                <li>техническая поддержка.</li>
              </ul>
            </div>
          </div>
          <div
            style={{
              flex: "1",
              marginLeft: "1vw",
              marginRight: "1vw",
              backgroundColor: "#eaf0f3",
              borderRadius: "12px"
            }}
          >
            <div
              style={{
                borderRadius: "12px",
                padding: "0.3vw",
                paddingLeft: "0.4vw",
                paddingRight: "0.4vw"
              }}
            >
              <ul
                className="globalUlList"
                style={{ paddingInlineStart: "1.85em" }}
              >
                <li>сбор часовых и суточных архивов не реже чем в час;</li>
                <li>формирование документа в формате HTML-XML МОЭК;</li>
                <li>чтение текущих значений online;</li>
                <li>sms уведомления о нештатных ситуациях;</li>
                <li>техническая поддержка.</li>
              </ul>
            </div>
          </div>
        </div>
        <div style={{ flex: "0.4", textAlign: "center" }}>
          <Link to="/tariffs">
            <div>Подробнее...</div>
          </Link>
        </div>
      </div>
    );
  }
}

export default TariffsSlide;
